import {PRODUCTION} from "@irati/utils/constants/environment"

const prodKey = "5b01c24438ba476b859feb2fab9d3b40@sentry.io/241134"
const stagingKey = "cb9b06f3fef448cc983facda983e80f5@sentry.io/231364"

export default function getSentryUrl(env: string) {
  switch (env) {
    case PRODUCTION:
      return prodKey
    default:
      return stagingKey
  }
}
